import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../common/containers/icon';
import TruLogo from './TruLogo';

/**
 * Thin top bar for the sidebar layout.
 * Contains: logo (left), hamburger for mobile (left). Global nav is in the sidebar.
 */
const MinimalTopBar = ({
  onOpenDrawer,
  onCloseDrawer,
  drawerOpen: _drawerOpen = false
}) => /*#__PURE__*/React.createElement("header", {
  className: "minimal-top-bar",
  role: "banner"
}, /*#__PURE__*/React.createElement("button", {
  type: "button",
  className: "minimal-top-bar__hamburger",
  onClick: _drawerOpen ? onCloseDrawer : onOpenDrawer,
  "aria-label": _drawerOpen ? 'Close navigation' : 'Open navigation',
  "aria-expanded": _drawerOpen,
  "aria-controls": "global-nav-sidebar"
}, /*#__PURE__*/React.createElement(Icon, {
  glyph: "bars"
})), /*#__PURE__*/React.createElement("div", {
  className: "minimal-top-bar__logo"
}, /*#__PURE__*/React.createElement("a", {
  href: "/"
}, /*#__PURE__*/React.createElement(TruLogo, {
  width: "80px"
}))));
MinimalTopBar.propTypes = {
  onOpenDrawer: PropTypes.func.isRequired,
  onCloseDrawer: PropTypes.func.isRequired,
  drawerOpen: PropTypes.bool
};
export default MinimalTopBar;